<template>
    <div class="user-avator-dropdown">
        <!-- <Badge :dot="isNoRead"
            style="margin-right:10px">
            <common-icon type="_xiaoxi"
                :size="20"
                @click.native="toShowMessage"></common-icon> 
        </Badge>-->
        <Dropdown @on-click="handleClick"
            placement="top"
            transfer>
            <Avatar :src="userAvator" />
            <span style="font-size: 14px;margin-left: 10px">{{user.nickName || user.nickname ||user.username}}</span>
            <Icon :size="18"
                type="md-arrow-dropdown"></Icon>
            <DropdownMenu slot="list">
                <DropdownItem name="resetPwd">修改密码</DropdownItem>
                <DropdownItem name="logout">退出登录</DropdownItem>
            </DropdownMenu>
        </Dropdown>
        <smart-modal :title="'修改密码'"
            :height="400"
            :width="600"
            v-model="showResetPwdForm"
            :maskClosable="maskClosable"
            @close-by-confirm="logOut">
            <reset-pwd v-if="showResetPwdForm"
                :id="id"></reset-pwd>
        </smart-modal>
    </div>
</template>
<script>
import './user.less'
import { mapActions } from 'vuex'
import { resetRouter } from '@/boot/create-router'
import ResetPwd from './reset-pwd'

export default {
    name: 'User',
    access: "user",
    components: {
        ResetPwd,
    },
    props: {
        userAvator: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            id: '',
            showResetPwdForm: false,
            maskClosable: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user.info
        },
        isNoRead() {
            return this.user.noReadCount > 0
        }
    },
    methods: {
        toShowMessage() {
            this.$router.push({
                name: "msg",
            });
        },
        ...mapActions([
            'handleLogOut'
        ]),
        handleClick(name) {
            switch (name) {
                case 'logout':
                    this.logOut()
                    break
                case 'resetPwd':
                    this.id = this.$store.state.user.info.id
                    this.showResetPwdForm = true
                    break
            }
        },
        logOut() {
            return this.handleLogOut()
                .then(() => {
                    // 重置路由
                    resetRouter(this.$router, {
                        routes: this.$config.routes,
                        mode: this.$config.routerMode,
                        base: this.$config.routerBase,
                    })
                    // 跳转到登录页面
                    this.$router.push({
                        name: 'login'
                    })
                })
        }
    }
}
</script>
